import { ReactComponent as Travel } from './travel.svg';
import { ReactComponent as Avatar } from './profile.svg';
import { ReactComponent as Arrow1 } from './arrow_1.svg';
import { ReactComponent as Arrow2 } from './arrow_2.svg';
import { ReactComponent as Mail } from './letter.svg';
import { ReactComponent as Nairi } from './nairi_logo.svg';
import { ReactComponent as Message } from './message.svg';
import { ReactComponent as Home } from './home.svg';
import { ReactComponent as Car } from './car.svg';
import { ReactComponent as Bus } from './bus.svg';
import { ReactComponent as Pickup } from './pickup.svg';
import { ReactComponent as Trailer } from './trailer.svg';
import { ReactComponent as Moto } from './moto.svg';
import { ReactComponent as Health } from './health.svg';
import { ReactComponent as Heart } from './family.svg';
import { ReactComponent as Finance } from './finance.svg';
import { ReactComponent as Accident } from './accident.svg';
import { ReactComponent as DeathCar } from './death_of_car.svg';
import { ReactComponent as Contingencies } from './contingencies.svg';
import { ReactComponent as Document } from './document.svg';
import { ReactComponent as AddCard } from './add_card.svg';
import { ReactComponent as AppleStore } from './apple.svg';
import { ReactComponent as Close } from './close.svg';
import { ReactComponent as Corporation } from './corporation.svg';
import { ReactComponent as DownArrow } from './down-arrow.svg';
import { ReactComponent as Facebook } from './facebook.svg';
import { ReactComponent as Instagram } from './instagram.svg';
import { ReactComponent as PlayStore } from './play_market.svg';
import { ReactComponent as Reimbursement } from './reimbursement.svg';
import { ReactComponent as Sedan } from './sedan.svg';
import { ReactComponent as Send } from './send.svg';
import { ReactComponent as Success } from './success.svg';
import { ReactComponent as LeftMenuIcon } from './leftMenuIcon.svg';

export {
  AddCard,
  AppleStore,
  Close,
  Corporation,
  DownArrow,
  Facebook,
  Instagram,
  PlayStore,
  Reimbursement,
  Sedan,
  Send,
  Success,
  Travel,
  Avatar,
  Arrow1,
  Arrow2,
  Mail,
  Nairi,
  Message,
  Home,
  Car,
  Bus,
  Pickup,
  Trailer,
  Moto,
  Health,
  Heart,
  Finance,
  Accident,
  DeathCar,
  Contingencies,
  Document,
  LeftMenuIcon
};
